import React, { useState, useEffect } from "react";
import { CircleCheck, X } from "lucide-react";
import  Logo  from "../../assets/icons/popup/e-lotto-pcso-logo 1.svg?react";
import QR from "../../assets/icons/popup/QR-CODE.svg?react";
import { QRCodeSVG } from "qrcode.react";

export default function CopyPopup({ isOpen, onClose, referralCode }) {
  const [isVisible, setIsVisible] = useState(false); // Controls rendering in DOM
  const [isAnimating, setIsAnimating] = useState(false); // Controls animation classes
  const [showCopyPopup, setShowCopyPopup] = useState(false); // State for referral copy popup
  const [copyPopupAnimating, setCopyPopupAnimating] = useState(false); // Animation state for copy popup

  // Handle the main popup animation
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Handle the Copy Popup animation
  const handleCopyPopup = () => {
    setShowCopyPopup(true);
    setTimeout(() => setCopyPopupAnimating(true), 10); // Start animation
    setTimeout(() => {
      setCopyPopupAnimating(false); // End animation
      const timer = setTimeout(() => setShowCopyPopup(false), 300);
      return () => clearTimeout(timer);
    }, 3000); // Close copy popup after 3 seconds
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.origin + "/register?code=" + referralCode);
    onClose();
    handleCopyPopup();
  };

  const getReferralLink = () => {
    return window.location.origin + "/register?code=" + referralCode;
  }

  return (
    <>
      {/* Main Popup */}
      {isVisible && (
        <div
          className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${
            isAnimating ? "opacity-100" : "opacity-0"
          }`}
        >
          <div
            className={`relative w-full p-4 max-w-sm bg-white text-black rounded-3xl overflow-hidden transition-transform duration-300 ${
              isAnimating ? "scale-100" : "scale-90"
            }`}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-gray-300 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>

            {/* Main Content */}
            <div className="px-4 text-center mt-5">
              <div className="flex justify-center items-center mb-4">
                <Logo className="object-cover" />
              </div>

              <h2 className="text-xl font-semibold text-center my-2 leading-none">
                Scan QR Code
              </h2>
              <p className="text-xs font-normal">
                Scan this QR code to register
              </p>

              {/* QR Code */}
              <div className="bg-white p-2 rounded-lg w-44 mx-auto shadow-md">
                <QRCodeSVG 
                  value={getReferralLink()} 
                  className="w-44 h-44"/>
              </div>

              {/* Referral Code */}
              <div className="text-center">
                <div className="text-[#0E64D1] text-xl font-semibold my-2">
                  {referralCode}
                </div>
                <div className="text-gray-400 text-[10px] mb-2">
                  — or download/copy the referral link —
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-center gap-3 my-2">
                <button className="bg-[#0E64D1] hover:bg-blue-600 text-white py-3 px-4 rounded-lg transition-colors">
                  Download
                </button>
                <button
                  onClick={handleCopy}
                  className="bg-[#0E64D1] hover:bg-blue-600 text-white py-3 px-4 rounded-lg transition-colors"
                >
                  Copy Link
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Copy Popup */}
      {showCopyPopup && (
        <div
          className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${
            copyPopupAnimating ? "opacity-100" : "opacity-0"
          }`}
        >
          <div
            className={`relative w-full py-8 px-4 max-w-sm bg-white text-black rounded-3xl transition-transform duration-300 ${
              copyPopupAnimating ? "scale-100" : "scale-90"
            }`}
          >
            {/* Notification Content */}
            <div className="flex justify-center items-center gap-2.5">
              <CircleCheck className="text-[#0E64D1] w-20 h-20 max-xs:w-16 max-xs:h-16" />
              <h3 className="text-2xl font-normal max-xs:text-lg">Referral Link Copied!</h3>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
